import React from "react";

import { Link, useNavigate } from "react-router-dom";
import { doLogout } from "../../services/authService";

function SideBar({ isAdmin }) {
  const navigate = useNavigate();

  function getClassName(item) {
    return window.location.pathname === item ? "nav-item active" : "nav-item";
  }

  function cleanAndRedirect() {
    /*localStorage.removeItem("token");
    history.push("/");*/
    navigate("/");
  }

  function handleLogoutClick(e) {
    e.preventDefault();
    /*doLogout(localStorage.getItem("token"))
      .then((response) => cleanAndRedirect())
      .catch((error) => {
        console.log(error);
        cleanAndRedirect;
      });*/
    doLogout();
    cleanAndRedirect();
  }

  return (
    <>
      <nav
        id="sidebarMenu"
        className="sidebar d-lg-block bg-gray-800 text-white collapse"
        data-simplebar
      >
        <div className="sidebar-inner px-4 pt-3">
          <div className="user-card d-flex d-md-none align-items-center justify-content-between justify-content-md-center pb-4">
            <div className="collapse-close d-md-none">
              <a
                href="#sidebarMenu"
                data-bs-toggle="collapse"
                data-bs-target="#sidebarMenu"
                aria-controls="sidebarMenu"
                aria-expanded="true"
                aria-label="Toggle navigation"
              >
                <img
                  className="navbar-brand-dark"
                  src="/img/brand/logo_dfsi.jpg"
                  alt="app logo"
                />
              </a>
            </div>
          </div>
          <ul className="nav flex-column pt-3 pt-md-0">
            <li className="nav-item">
              <Link
                to="/dashboard"
                className="nav-link d-flex align-items-center"
              >
                <span className="sidebar-icon">
                  <img
                    src="/img/brand/logo_dfsi.jpg"
                    height="20"
                    width="20"
                    alt="App Logo"
                  />
                </span>
                <span className="mt-1 ms-1 sidebar-text">App Menu</span>
              </Link>
            </li>
            <li className={getClassName("/dashboard")}>
              <Link to="/dashboard" className="nav-link">
                <span className="sidebar-icon">
                  <svg
                    className="icon icon-xs me-2"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M2 10a8 8 0 018-8v8h8a8 8 0 11-16 0z"></path>
                    <path d="M12 2.252A8.014 8.014 0 0117.748 8H12V2.252z"></path>
                  </svg>
                </span>
                <span className="sidebar-text">Dashboard</span>
              </Link>
            </li>
            {isAdmin && (<li className={getClassName("/financeiro")}>
              <Link
                to="/financeiro"
                className="nav-link d-flex justify-content-between"
              >
                <span>
                  <span className="sidebar-icon">

                    <svg
                      className="icon icon-xs me-2"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path d="M4 4a2 2 0 00-2 2v1h16V6a2 2 0 00-2-2H4z"></path>
                      <path
                        fillRule="evenodd"
                        d="M18 9H2v5a2 2 0 002 2h12a2 2 0 002-2V9zM4 13a1 1 0 011-1h1a1 1 0 110 2H5a1 1 0 01-1-1zm5-1a1 1 0 100 2h1a1 1 0 100-2H9z"
                        clipRule="evenodd"
                      ></path>
                    </svg>

                  </span>
                  <span className="sidebar-text">Faturação</span>
                </span>
              </Link>
            </li>)}
            <li className={getClassName("/inscricoes")}>
              <Link to="/inscricoes" className="nav-link">
                <span className="sidebar-icon">
                  
                  <svg
                    className="icon icon-xs me-2"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M5 3a2 2 0 00-2 2v2a2 2 0 002 2h2a2 2 0 002-2V5a2 2 0 00-2-2H5zM5 11a2 2 0 00-2 2v2a2 2 0 002 2h2a2 2 0 002-2v-2a2 2 0 00-2-2H5zM11 5a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V5zM11 13a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z"></path>
                  </svg>

                </span>
                <span className="sidebar-text">Inscricoes</span>
              </Link>
            </li>
            <li className={getClassName("/outros")}>
              <Link to="/outros" className="nav-link">
                <span className="sidebar-icon">
                  
                  <svg
                    className="icon icon-xs me-2"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M5 3a2 2 0 00-2 2v2a2 2 0 002 2h2a2 2 0 002-2V5a2 2 0 00-2-2H5zM5 11a2 2 0 00-2 2v2a2 2 0 002 2h2a2 2 0 002-2v-2a2 2 0 00-2-2H5zM11 5a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V5zM11 13a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z"></path>
                  </svg>

                </span>
                <span className="sidebar-text">Outros</span>
              </Link>
            </li>
            <li className={getClassName("/settings")}>
              <Link to="/settings" className="nav-link">
                <span className="sidebar-icon">
                  <svg
                    className="icon icon-xs me-2"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      d="M11.49 3.17c-.38-1.56-2.6-1.56-2.98 0a1.532 1.532 0 01-2.286.948c-1.372-.836-2.942.734-2.106 2.106.54.886.061 2.042-.947 2.287-1.561.379-1.561 2.6 0 2.978a1.532 1.532 0 01.947 2.287c-.836 1.372.734 2.942 2.106 2.106a1.532 1.532 0 012.287.947c.379 1.561 2.6 1.561 2.978 0a1.533 1.533 0 012.287-.947c1.372.836 2.942-.734 2.106-2.106a1.533 1.533 0 01.947-2.287c1.561-.379 1.561-2.6 0-2.978a1.532 1.532 0 01-.947-2.287c.836-1.372-.734-2.942-2.106-2.106a1.532 1.532 0 01-2.287-.947zM10 13a3 3 0 100-6 3 3 0 000 6z"
                      clipRule="evenodd"
                    ></path>
                  </svg>
                </span>
                <span className="sidebar-text">Definições</span>
              </Link>
            </li>
            <li
              role="separator"
              className="dropdown-divider mt-4 mb-3 border-gray-700"
            ></li>
            <li className="nav-item">
              <Link
                to=""
                onClick={handleLogoutClick}
                className="nav-link d-flex align-items-center"
              >
                <span className="sidebar-icon">
                  <svg
                    className="icon icon-xs me-2"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 20 20"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"
                    ></path>
                  </svg>
                </span>
                <span className="sidebar-text">Sair</span>
              </Link>
            </li>
          </ul>
        </div>
      </nav>
    </>
  );
}

export default SideBar;
